<template>
  <div class="p-mr-3">
    <router-link
      :to="{
        name: 'bovine.edit',
        params: { id: saleBovine.bovine.id },
      }"
      target="_blank"
      style="text-decoration: none"
    >
      {{ saleBovine.bovine.earring }}
    </router-link>
  </div>
  <BovineType small :type="saleBovine.bovine.type" />
</template>

<script>
import BovineType from '../../../components/BovineType';

export default {
  name: 'SaleBovineHeader',
  props: {
    saleBovine: Object,
  },
  components: {
    BovineType,
  },
};
</script>

<style>
</style>